import React from 'react';
import * as S from './styles';

const CrossPromoContent = (props = {}) => (
    <S.CrossPromoContent
        border={props.border}
        height={props.height}
    >
        {props.children}
    </S.CrossPromoContent>
);

export default CrossPromoContent;
